module.exports = __webpack_public_path__ + "img/mobile_index_banner_2.0478fcbd.jpg";